import React from 'react';
import CompanyDocumentsTabView from './CompanyDocumentsTabView';
import { useCompanyDocumentsTabController } from '../../../controllers';
import { CompanyDocumentsTabProps } from '../../../types';

const CompanyDocumentsTab = (props: CompanyDocumentsTabProps) => {
  const viewModel = useCompanyDocumentsTabController(props);
  return <CompanyDocumentsTabView {...viewModel} />;
};

export default CompanyDocumentsTab;
